<template lang="pug">
  .rangeslider(v-bind:class="{'-active': dragging}")
    .rangeslider_component
      .rangeslider_slider
</template>
<script>
  import 'webpack-jquery-ui/slider';
  import $ from 'jquery';
  import _ from 'lodash';

  export default {
    props: ['values', 'selected'],
    data: function(){
      return {
        dragging: false,
        $slider: undefined
      }
    },
    computed: {
      current: function(){
        return this.values.indexOf(this.selected);
      }
    },
    mounted: function(){
      this.create();
    },
    methods: {
      create(){
        let self = this;

        this.$slider = $('.rangeslider_slider').slider({
          min: 0,
          max: (this.values.length - 1) || 1,
          value: this.current,
          create: function(e){
            let _ui = $(this);
            _ui.handle = _ui.find('.ui-slider-handle');
            _ui.value = self.current;
            self.update.call(self, e, _ui);
          },
          slide: function(e, ui){
            self.update.call(self, e, ui);

            let index = ui.value;
            let value = self.values[index];
            self.$emit('slider_change', value);
          },
          change: function(e, ui){
            self.update.call(self, e, ui);
          },
          start: function(){
            self.dragging = true;
          },
          stop: function(){
            self.dragging = false;
          }
        });
      },
      update(e, ui){
        let $handle = $(ui.handle);
        let index = ui.value;
        let value = this.values[index];
        //console.log( e, ui, index, value);

        $handle.attr('data-year', value);
      }
    },
    watch: {
      values: function(newValue, oldValue){
        if(newValue && newValue.length > 0 && !_.isEqual(newValue, oldValue)) {
          this.$slider.slider('destroy');
          delete this.$slider;

          this.create();
        }
      },
      selected: function(){
        //this.current = val;
        this.$slider.slider('value', this.current);
      }
    }
  }
</script>
<style lang="sass">
  .rangeslider
    width: 100%
    &.-active
      .rangeslider_component
        background-color: #F0DC00
      .rangeslider_slider
        .ui-slider-handle
          color: #F0DC00

    .rangeslider_component
      background-color: #fff
      width: 100%
      height: 16px
      border-radius: 16px
      //border-right: 48px solid transparent
      padding: 0 8px
      box-sizing: border-box
      position: relative

      transition: background-color .1s linear

      &:before
        content: ''
        display: block
        background-color: #666
        border-radius: 2px
        height: 2px
        width: calc(100% - 16px)
        position: absolute
        top: 50%
        left: 8px
        transform: translate(0, -50%)

    .rangeslider_slider
      height: 100%
      .ui-slider-handle
        width: 0
        height: 0
        font-size: 0
        outline: none

        &:after
          display: block
          content: attr(data-year)
          width: 48px
          height: 48px
          color: #fff
          background-color: #000
          border-radius: 50%
          position: absolute
          top: -16px
          left: 0
          margin-left: auto
          line-height: 48px
          text-align: center
          font-weight: bold
          font-size: 15px
          font-family: Helvetica, 'Helvetica Neue', Arial, sans-serif
          cursor: pointer
          transform: translate(-50%, 0)

          transition: color .1s linear

        //
</style>